import { render, staticRenderFns } from "./SecondGraduationInstitutionInfo.vue?vue&type=template&id=a954e50a&scoped=true&"
import script from "./SecondGraduationInstitutionInfo.vue?vue&type=script&lang=ts&"
export * from "./SecondGraduationInstitutionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SecondGraduationInstitutionInfo.vue?vue&type=style&index=0&id=a954e50a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a954e50a",
  null
  
)

export default component.exports